var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","justify-center":""}},[_c('item-list',{attrs:{"allowAdd":"","allowDelete":"","endpoint":_vm.endpoint + 'apikeys',"editRoute":"apikeyEdit","headers":_vm.headers,"id":"_id","name":"API Key","searchBarText":_vm.searchBarText,"permissions":"apikeys"}})],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5875006a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiKeys.vue
// module id = mCgs
// module chunks = 1